export const FEATURES = {
  AVG_WHEELS: "AVG_WHEELS", //how many wheels can be created
  SPACE_ALLOCATED: "SPACE_ALLOCATED", //how much space is allocated
  MESSAGING: "MESSAGING",
  REFFERAL_PROGRAM: "REFFERAL_PROGRAM",
  ANALYTICS: "ANALYTICS",
  BUSINESS_BOX: "BUSINESS_BOX",
  SEO: "SEO",
  WHEEL_WALLPAPER_IMAGE: "IMAGES", // can upload wallpaper image
  SHORTCUT_HOTBAR: "SHORTCUT_HOTBAR",
  ADV_PALLETE_GENERATOR: "ADV_PALLETE_GENERATOR",
  CUSTOM_HEX_COLORS: "C_HEX_COLORS",
  TEMPLATE: "TEMPLATE",
  LOCKABLE_WHEELS: "LOCKABLE_WHEELS", //can lock wheels
  CLONING_WHEELS: "CLONING_WHEELS", //how many wheels can be cloned
  CLONING_STORAGE: "CLONING_STORAGE", //how many clones can be stored
  AI_CS_CHAT: "AI_CS_CHAT",
  AI_TEXT_SUGGESTIONS: "AI_TEXT_SUGGESTIONS",
  AI_WHEEL_GENERATOR: "AI_WHEEL_GENERATOR",
  TEXT_ONLY: "TEXT_ONLY",
  UPLOAD_VIDEOS: "UPLOAD_VIDEO",
  PALETTE_AI_TEXT: "PALETTE_AI_TEXT", //can generate palette from text
  PALETTE_AI_IMAGE: "PALETTE_AI_IMAGE", //can generate palette from image
  AI_MEDIA_UPLOADS: "MEDIA_UPLOAD",
};